module.exports = __webpack_public_path__ + "images/refer-a-friend.jpg";